import { accountEntityName } from '../../../../../backend/features/accounts/shared';
import { createLogCustom } from '../../../../../backend/features/audit';
import { removeMembersFromOrganizationBulkActionEvent } from '../../../../../backend/features/audit/shared';
import { handleRemoveAccountFromOrganization } from '../../../../../backend/features/organizations/bulk-actions/removeAccountsFromOrganization/handleRemoveAccountFromOrganization';
import { organizationEntityName, orgColumnForAuditIdReplacement, } from '../../../../../backend/features/organizations/shared';
import { allowOrgMembersEdit, getAccountsViewFilterNew, requireAnySystemPermission } from '../../../../../backend/features/permissions/shared';
import { forEachEntityRow } from '../../../../../backend/utils';
import { AuthError } from '@juvare/platform-app/App';
import { defineBulkAction } from '@juvare/platform-sdk-react/backend/features/bulk-actions';
import { removeAccountsFromOrganizationBulkActionType, } from '../../shared/bulk-actions/removeAccountsFromOrganizationTypes';
export const removeAccountsFromOrganization = defineBulkAction({
    type: removeAccountsFromOrganizationBulkActionType,
    onAuthBulkAction: (userContext, { createdBy, data }) => {
        if (!allowOrgMembersEdit(userContext.userState)) {
            throw new AuthError('Unauthorized');
        }
        const secureFilter = [...getAccountsViewFilterNew(userContext.userState), ...data.params.filter];
        if (!requireAnySystemPermission(userContext.userState, 'all-organizations-admin')) {
            secureFilter.push({ id: createdBy, op: '!=' });
        }
        return {
            secureFilter,
        };
    },
    onProcessBulkAction: (appContext, params) => {
        const accountStorage = appContext.storage(accountEntityName);
        const actionOwner = accountStorage.get(params.createdBy);
        const ids = [];
        forEachEntityRow(accountStorage, { filter: params.data.secureParams.secureFilter, orderBy: [{ column: 'email' }] }, (row, idx) => {
            const result = handleRemoveAccountFromOrganization({
                appContext,
                secureBulkActionParams: params,
                row,
                accountStorage,
                actionOwner,
                processedIndex: idx,
            });
            ids.push(row.id);
            return result;
        }, params.updateTotalCount);
        const orgStorage = appContext.storage(organizationEntityName);
        const organization = orgStorage.get(params.data.params.organizationId);
        const logCustomStrict = createLogCustom(appContext.audit);
        logCustomStrict({
            eventType: removeMembersFromOrganizationBulkActionEvent,
            entity: organizationEntityName,
            entityId: organization.id,
            params: { ids, auditColumnValue: organization.columns[orgColumnForAuditIdReplacement] },
        });
    },
});
